import React, { useState } from 'react';
import SelectStudentModal from './SelectStudentModal';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import { useParams } from 'react-router-dom';
import { permissionsKeyMap } from 'routes/permissions/permissionKeys';
import TableRowAction from 'components/common/TableRowAction';
import dayjs from 'dayjs';
import { useAuthContext } from 'context/authContext';
import {
  useSchoolOrphans,
  useCreateSchoolStudent,
  useDeleteSchoolStudent
} from 'hooks/useBeneficiaries';

const StudentsTable = () => {
  const { id } = useParams();
  const { organization, selectedBranchId, user } = useAuthContext();
  const [showStudentAddModal, setShowStudentAddModal] = useState(false);

  const { schoolOrphans, isLoading: loading } = useSchoolOrphans(id);
  const { deleteSchoolStudent, isDeleting } = useDeleteSchoolStudent();
  const { createSchoolStudent, isCreating: addSchoolloading } = useCreateSchoolStudent();

  const calculateAge = DOB => {
    const birthDate = dayjs(DOB);
    const currentDate = dayjs();
    const age = currentDate.diff(birthDate, 'year');
    return age;
  };

  const removeStudent = orphanId => {
    deleteSchoolStudent(orphanId);
  };

  const schoolColumns = [
    {
      accessor: 'full_name',
      Header: 'Name',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { first_name, last_name } = rowData.row.original;
        return <>{first_name + ' ' + last_name}</>;
      }
    },
    {
      accessor: 'DOB',
      Header: 'Age',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { DOB } = rowData.row.original;
        return <>{calculateAge(DOB)}</>;
      }
    },
    {
      accessor: 'gender',
      Header: 'Gender',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { gender } = rowData.row.original;
        return <>{gender}</>;
      }
    },
    {
      accessor: 'created_at',
      Header: 'Registration',
      Cell: rowData => {
        const { created_at } = rowData.row.original;
        return <>{dayjs(created_at).format('MMM-DD-YYYY')}</>;
      }
    },
    {
      accessor: 'inspiration',
      Header: 'Aspiration',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { inspiration } = rowData.row.original;
        return <>{inspiration}</>;
      }
    },
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { status } = rowData.row.original;
        return <>{status}</>;
      }
    },
    {
      accessor: 'id_',
      Header: '',
      cellProps: {
        className: 'py-2 text-end'
      },
      disableSortBy: true,

      Cell: rowData => {
        const { id } = rowData.row.original;
        return (
          <TableRowAction
            onCLickDelete={() => removeStudent(id)}
            isNotEdit
            subject={permissionsKeyMap.facilities.children.school}
          />
        );
      }
    }
  ];

  const submitStudent = value => {
    createSchoolStudent({
      school_id: id,
      orphan_id: value,
      branch_id: selectedBranchId,
      organisation_id: organization.id,
      user_id: user.id
    });
  };

  return (
    <>
      {!loading && (
        <CustomAdvanceTable
          loading={loading}
          data={
            schoolOrphans?.map((student, index) => ({
              ...student?.orphan,
              key: `${student?.orphan?.id}-${index}`
            })) || []
          }
          columns={schoolColumns}
          title="Orphans"
          addButtonLabel="Add Students"
          addButtonIcon="user"
          onClickAddNew={() => {
            setShowStudentAddModal(true);
          }}
          addNew
          subject={permissionsKeyMap.facilities.children.school}
        />
      )}

      <SelectStudentModal
        show={showStudentAddModal}
        onHide={() => setShowStudentAddModal(false)}
        onSubmit={submitStudent}
        addSchoolloading={addSchoolloading}
      />
    </>
  );
};

export default StudentsTable;
